// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  background-color: #f5f5f5;
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
  -webkit-box-sizing: border-box;
          box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Roboto, OpenSans, HelveticaNeue-Light, Helvetica Neue Light,
    Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;
}

body {
  font-size: 14px;
  line-height: 1.5;
}

:root {
  /* Main themes */
  --default-color: #BFCBED;
  --active-color: #8784EE;
  --ui-border-color: #4A5582;
  --ui-border-color-dark: #3C4468;
  --ui-border-color-darker: #181a26;
  --hover: #1C2A36;

  /* Secondary themes */
  --hover-color: #ffffff;
  --ui-border-color-active: #8784EE;
  --primary-background-color: #000000;
  --box-background-color: #4A5582;

  /* Common palette */
  --ui-yellow: #E29E4A;
  --ui-sky-blue: #6FBDE2;

  /* State palette */
  --ui-state-error: #FFCCCC;
  --ui-state-error-border: #993333;
  --ui-state-error-text: #661111;
  --ui-gray-light: #516873;
  --ui-gray: #263340;
  --ui-gray-dark: #16202B;
  --ui-gray-darker: #151A1F;
  --ui-gray-darkest: #14202A;

  /* Text colors */
  --text-color-active: #000000;
  --text-primary-color: #ffffff;
  --text-secondary-color: #BFCBED;
  --large-numbers-color: #8784EE;
  --text-disabled-color: #878787;
  --input-background-color: #2c363f;
  --input-placeholder-color--hover: #4d5a63;
  --input-placeholder-color: #d3d3d3;
  --table-hover-color: #2c363f;
  --table-text-primary-color: #ffffff;
  --table-text-secondary-color: #BFCBED;
  --large-numbers-color: #8784EE;
  --state-error: #FFCCCC;
  --state-error-border: #FFCCCC;
  --state-error-text: #FFCCCC;

  /* Sizes */
  --top-bar-height: 50px;
  --top-bar-expanded-height: 160px;
  --toolbar-height: 70px;
  --toolbar-drawer-height: 62px;
  --left-sidepanel-menu-width: 307px;
  --right-sidepanel-menu-width: 323px;
  --study-list-padding: 8%;
  --study-list-padding-medium-screen: 10px;
  --snackbar-size: 344px;

  /* Transitions */
  --transition-duration: 0.3s;
  --transition-effect: ease;
  --sidepanel-transition: all 0.3s ease;

  /* Thicknesses */
  --viewport-border-thickness: 1px;
  --ui-border-thickness: 1px;

  /** Colors **/
  --snackbar-success: rgba(94, 164, 0, 0.9);
  --snackbar-error: rgba(236, 61, 61, 0.9);
  --snackbar-warning: rgba(235, 173, 23, 0.9);
  --snackbar-info: rgba(54, 156, 199, 0.9);

  /** z-Index **/
  --snackbar-zIndex: 1075;

  /** DatePicker colors **/
  --datePicker-input-background: #2c363f;
  --datePicker-picker-background: #9ccef9;
  --datePicker-picker-disabled: #d3d3d3;
  --datePicker-picker-text: #484848;
  --datePicker-picker-text-disabled: #aaa;
  --datePicker-picker-text-input: #fff;
}
`, "",{"version":3,"sources":["webpack://./main.css"],"names":[],"mappings":"AAAA;;;EAGE,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,UAAU;EACV,8BAA8B;UACtB,sBAAsB;EAC9B,mCAAmC;EACnC,kCAAkC;EAClC;+DAC6D;AAC/D;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,gBAAgB;;EAEhB,qBAAqB;EACrB,sBAAsB;EACtB,iCAAiC;EACjC,mCAAmC;EACnC,+BAA+B;;EAE/B,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;;EAEtB,kBAAkB;EAClB,yBAAyB;EACzB,gCAAgC;EAChC,8BAA8B;EAC9B,wBAAwB;EACxB,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;;EAE1B,gBAAgB;EAChB,4BAA4B;EAC5B,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;EAC9B,iCAAiC;EACjC,yCAAyC;EACzC,kCAAkC;EAClC,4BAA4B;EAC5B,mCAAmC;EACnC,qCAAqC;EACrC,8BAA8B;EAC9B,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;;EAE3B,UAAU;EACV,sBAAsB;EACtB,gCAAgC;EAChC,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;EAClC,mCAAmC;EACnC,wBAAwB;EACxB,wCAAwC;EACxC,sBAAsB;;EAEtB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,qCAAqC;;EAErC,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;;EAE1B,aAAa;EACb,yCAAyC;EACzC,wCAAwC;EACxC,2CAA2C;EAC3C,wCAAwC;;EAExC,cAAc;EACd,uBAAuB;;EAEvB,wBAAwB;EACxB,sCAAsC;EACtC,uCAAuC;EACvC,qCAAqC;EACrC,iCAAiC;EACjC,uCAAuC;EACvC,oCAAoC;AACtC","sourcesContent":["html,\nbody,\n#root {\n  background-color: #f5f5f5;\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-family: Roboto, OpenSans, HelveticaNeue-Light, Helvetica Neue Light,\n    Helvetica Neue, Helvetica, Arial, Lucida Grande, sans-serif;\n}\n\nbody {\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n:root {\n  /* Main themes */\n  --default-color: #BFCBED;\n  --active-color: #8784EE;\n  --ui-border-color: #4A5582;\n  --ui-border-color-dark: #3C4468;\n  --ui-border-color-darker: #181a26;\n  --hover: #1C2A36;\n\n  /* Secondary themes */\n  --hover-color: #ffffff;\n  --ui-border-color-active: #8784EE;\n  --primary-background-color: #000000;\n  --box-background-color: #4A5582;\n\n  /* Common palette */\n  --ui-yellow: #E29E4A;\n  --ui-sky-blue: #6FBDE2;\n\n  /* State palette */\n  --ui-state-error: #FFCCCC;\n  --ui-state-error-border: #993333;\n  --ui-state-error-text: #661111;\n  --ui-gray-light: #516873;\n  --ui-gray: #263340;\n  --ui-gray-dark: #16202B;\n  --ui-gray-darker: #151A1F;\n  --ui-gray-darkest: #14202A;\n\n  /* Text colors */\n  --text-color-active: #000000;\n  --text-primary-color: #ffffff;\n  --text-secondary-color: #BFCBED;\n  --large-numbers-color: #8784EE;\n  --text-disabled-color: #878787;\n  --input-background-color: #2c363f;\n  --input-placeholder-color--hover: #4d5a63;\n  --input-placeholder-color: #d3d3d3;\n  --table-hover-color: #2c363f;\n  --table-text-primary-color: #ffffff;\n  --table-text-secondary-color: #BFCBED;\n  --large-numbers-color: #8784EE;\n  --state-error: #FFCCCC;\n  --state-error-border: #FFCCCC;\n  --state-error-text: #FFCCCC;\n\n  /* Sizes */\n  --top-bar-height: 50px;\n  --top-bar-expanded-height: 160px;\n  --toolbar-height: 70px;\n  --toolbar-drawer-height: 62px;\n  --left-sidepanel-menu-width: 307px;\n  --right-sidepanel-menu-width: 323px;\n  --study-list-padding: 8%;\n  --study-list-padding-medium-screen: 10px;\n  --snackbar-size: 344px;\n\n  /* Transitions */\n  --transition-duration: 0.3s;\n  --transition-effect: ease;\n  --sidepanel-transition: all 0.3s ease;\n\n  /* Thicknesses */\n  --viewport-border-thickness: 1px;\n  --ui-border-thickness: 1px;\n\n  /** Colors **/\n  --snackbar-success: rgba(94, 164, 0, 0.9);\n  --snackbar-error: rgba(236, 61, 61, 0.9);\n  --snackbar-warning: rgba(235, 173, 23, 0.9);\n  --snackbar-info: rgba(54, 156, 199, 0.9);\n\n  /** z-Index **/\n  --snackbar-zIndex: 1075;\n\n  /** DatePicker colors **/\n  --datePicker-input-background: #2c363f;\n  --datePicker-picker-background: #9ccef9;\n  --datePicker-picker-disabled: #d3d3d3;\n  --datePicker-picker-text: #484848;\n  --datePicker-picker-text-disabled: #aaa;\n  --datePicker-picker-text-input: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
